var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from "react";
import { Button, Form, Grid, Icon, Select } from "semantic-ui-react"; // Form used for inputs below
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { HcrAmplifier } from "../automated-pro/RnaCatalog";
import { priceColumn } from "../rna-fish/EditKitForm";
import { ComponentPriceDisplay } from "../rna-fish/ProbeSetForm";
var AutomatedIfDetectForm = /** @class */ (function (_super) {
    __extends(AutomatedIfDetectForm, _super);
    function AutomatedIfDetectForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            editing: false,
            editingAmplifiers: false
        };
        _this.getCurrentPairs = function () {
            var _a, _b, _c, _d, _e;
            var _f = _this.props, detectCatalog = _f.detectCatalog, plexity = _f.plexity, detectState = _f.detectState;
            if (detectState.snapCooledConfigId === -1) {
                return (_a = detectState.customAmpLabelPairs) !== null && _a !== void 0 ? _a : [];
            }
            return (_e = (_c = (_b = detectCatalog.configs.find(function (c) { return c.id === detectState.snapCooledConfigId; })) === null || _b === void 0 ? void 0 : _b.channels) !== null && _c !== void 0 ? _c : (_d = detectCatalog.configs.find(function (c) { return c.plexity === plexity; })) === null || _d === void 0 ? void 0 : _d.channels) !== null && _e !== void 0 ? _e : [];
        };
        _this.onEditClick = function () {
            _this.setState({ editing: true });
        };
        _this.onEditDone = function () {
            _this.setState({ editing: false, editingAmplifiers: false });
        };
        _this.onEditAmplifiersClick = function () {
            _this.setState({ editingAmplifiers: true });
        };
        _this.onLockAmplifiersClick = function () {
            _this.setState({ editingAmplifiers: false });
        };
        _this.onAmplifierChange = function (i) { return function (_, data) {
            var newPairs = __spreadArrays(_this.getCurrentPairs());
            newPairs[i] = __assign(__assign({}, newPairs[i]), { hcrAmplifier: new HcrAmplifier(data.value) });
            var snapCooledConfigId = resolveSnapCooledConfigId(newPairs, _this.props.detectCatalog);
            _this.props.onDetectChange(function () { return ({ snapCooledConfigId: snapCooledConfigId, customAmpLabelPairs: newPairs }); }, _this.props.onUserSelection);
        }; };
        _this.onFluorophoreChange = function (i) { return function (_, data) {
            var fluorophore = _this.props.availableFluorophores.find(function (f) { return f.id === data.value; });
            if (!fluorophore) {
                return;
            }
            var newPairs = __spreadArrays(_this.getCurrentPairs());
            newPairs[i] = __assign(__assign({}, newPairs[i]), { fluorophore: fluorophore });
            var snapCooledConfigId = resolveSnapCooledConfigId(newPairs, _this.props.detectCatalog);
            _this.props.onDetectChange(function () { return ({ snapCooledConfigId: snapCooledConfigId, customAmpLabelPairs: newPairs }); }, _this.props.onUserSelection);
        }; };
        _this.onPresnapCooledChange = function (_, data) {
            _this.props.onDetectChange(function () { return ({ snapCooledConfigId: data.value }); }, _this.props.onUserSelection);
        };
        _this.onDetectAMlChange = function (event) {
            var val = parseFloat(event.currentTarget.value);
            _this.props.onDetectChange(function () { return ({ detectAMl: isNaN(val) ? 0 : val }); });
        };
        _this.onDetectBMlChange = function (event) {
            var val = parseFloat(event.currentTarget.value);
            _this.props.onDetectChange(function () { return ({ detectBMl: isNaN(val) ? 0 : val }); });
        };
        _this.onDetectCMlChange = function (event) {
            var val = parseFloat(event.currentTarget.value);
            _this.props.onDetectChange(function () { return ({ detectCMl: isNaN(val) ? 0 : val }); });
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onDetectChange(function (oldState) { return ({
                customPrice: newStateFn(oldState.customPrice)
            }); }, callback);
        };
        return _this;
    }
    AutomatedIfDetectForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, plexity = _a.plexity, detectState = _a.detectState, errors = _a.errors, showErrors = _a.showErrors, enableCustomPrice = _a.enableCustomPrice, effectivePriceCents = _a.effectivePriceCents, listPriceCents = _a.listPriceCents, priceLoading = _a.priceLoading, scalesReadOnly = _a.scalesReadOnly;
        var selectOptions = __spreadArrays(this.props.detectCatalog.configs
            .filter(function (c) { return c.plexity === plexity; })
            .map(function (c) { return ({ text: c.label, value: c.id }); }), (detectState.snapCooledConfigId === -1
            ? [{ text: '(Custom)', value: -1 }]
            : []));
        var currentPairs = this.getCurrentPairs();
        var _b = this.props, allAmplifiers = _b.availableAmplifiers, allFluorophores = _b.availableFluorophores;
        return React.createElement(Grid, { columns: 4, stackable: true },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 16 },
                    React.createElement(FieldWithErrorDisplay, { errors: errors, errorPath: "", labelContent: "HCR™ Gold Amplifier - Presnapcooled Cocktail" },
                        React.createElement("div", { className: 'presnapcooled-selector' },
                            React.createElement(Select, { options: selectOptions, onChange: this.onPresnapCooledChange, value: detectState.snapCooledConfigId }),
                            React.createElement(Button, { basic: true, compact: true, size: 'mini', icon: true, onClick: this.onEditClick, type: 'button' },
                                React.createElement(Icon, { name: 'pencil' }))),
                        detectState.snapCooledConfigId === -1 && currentPairs.length > 0 && (React.createElement("div", { className: 'presnapcooled-pairs-summary' }, currentPairs.map(function (pair, i) { return (React.createElement("span", { key: i, className: 'presnapcooled-pair-chip' },
                            "Ch",
                            pair.channel,
                            ": ",
                            pair.hcrAmplifier.id,
                            " \u00B7 ",
                            pair.fluorophore.name)); })))))),
            this.state.editing && (React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 16 },
                    React.createElement("div", { className: 'amp-label-editor' }, currentPairs.map(function (pair, i) {
                        var usedAmplifiers = new Set(currentPairs.filter(function (_, j) { return j !== i; }).map(function (p) { return p.hcrAmplifier.id; }));
                        var usedFluorophores = new Set(currentPairs.filter(function (_, j) { return j !== i; }).map(function (p) { return p.fluorophore.id; }));
                        return React.createElement(React.Fragment, { key: i },
                            React.createElement("span", { className: 'amp-label-editor-channel' },
                                "Channel ",
                                pair.channel),
                            React.createElement(FieldWithErrorDisplay, { labelContent: 'HCR™ Amplifier', errors: errors, errorPath: "/detectComponent/ampLabelPairs/" + i + "/hcrAmplifierId", showErrors: showErrors },
                                React.createElement(Select, { options: allAmplifiers.map(function (a) { return ({ text: a.id, value: a.id, disabled: usedAmplifiers.has(a.id) }); }), value: pair.hcrAmplifier.id, onChange: _this.onAmplifierChange(i), disabled: !_this.state.editingAmplifiers })),
                            React.createElement(FieldWithErrorDisplay, { labelContent: 'Fluorophore', errors: errors, errorPath: "/detectComponent/ampLabelPairs/" + i + "/fluorophoreId", showErrors: showErrors },
                                React.createElement(Select, { options: allFluorophores.map(function (f) { return ({ text: f.name, value: f.id, disabled: usedFluorophores.has(f.id) }); }), value: pair.fluorophore.id, onChange: _this.onFluorophoreChange(i) })));
                    })),
                    React.createElement("div", { className: 'amp-label-editor-actions' },
                        !this.state.editingAmplifiers && (React.createElement(Button, { type: 'button', basic: true, color: 'orange', size: 'small', onClick: this.onEditAmplifiersClick },
                            React.createElement(Icon, { name: 'lock' }),
                            "Edit Amplifiers")),
                        this.state.editingAmplifiers && (React.createElement(Button, { type: 'button', basic: true, color: 'grey', size: 'small', onClick: this.onLockAmplifiersClick },
                            React.createElement(Icon, { name: 'lock open' }),
                            "Lock Amplifiers")),
                        React.createElement(Button, { type: 'button', basic: true, size: 'small', onClick: this.onEditDone }, "Done"))))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/detectComponent/detectAMl', errors: errors, labelContent: 'Detect A (mL)', labelFor: 'detectAMl', showErrors: showErrors },
                        React.createElement(Form.Input, { name: 'detectAMl', type: 'number', value: detectState.detectAMl, onChange: this.onDetectAMlChange, onBlur: this.props.onUserSelection, disabled: scalesReadOnly }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/detectComponent/detectBMl', errors: errors, labelContent: 'Detect B (mL)', labelFor: 'detectBMl', showErrors: showErrors },
                        React.createElement(Form.Input, { name: 'detectBMl', type: 'number', value: detectState.detectBMl, onChange: this.onDetectBMlChange, onBlur: this.props.onUserSelection, disabled: scalesReadOnly }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/detectComponent/detectCMl', errors: errors, labelContent: 'Detect C (mL)', labelFor: 'detectCMl', showErrors: showErrors },
                        React.createElement(Form.Input, { name: 'detectCMl', type: 'number', value: detectState.detectCMl, onChange: this.onDetectCMlChange, onBlur: this.props.onUserSelection, disabled: scalesReadOnly }))),
                priceColumn(React.createElement(ComponentPriceDisplay, { loading: priceLoading, effectivePriceCents: effectivePriceCents, listPriceCents: listPriceCents }), effectivePriceCents !== listPriceCents)),
            enableCustomPrice &&
                React.createElement(CustomPriceRow, { customPrice: detectState.customPrice, defaultEffectivePriceCents: effectivePriceCents, errors: errors, errorPathPrefix: '/detectComponent', onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection }));
    };
    return AutomatedIfDetectForm;
}(React.Component));
export default AutomatedIfDetectForm;
var resolveSnapCooledConfigId = function (pairs, catalog) { var _a, _b; return (_b = (_a = catalog.configs.find(function (config) {
    return pairs.length === config.channels.length &&
        pairs.every(function (pair) {
            return config.channels.some(function (ch) {
                return ch.hcrAmplifier.id === pair.hcrAmplifier.id &&
                    ch.fluorophore.id === pair.fluorophore.id &&
                    ch.channel === pair.channel;
            });
        });
})) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : -1; };
//# sourceMappingURL=AutomatedIfDetectForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-gold-if/AutomatedIfDetectForm.js
// module id = 1144
// module chunks = 0